import { render, staticRenderFns } from "./PowerBIReport.vue?vue&type=template&id=7805f567"
import script from "./PowerBIReport.vue?vue&type=script&lang=js"
export * from "./PowerBIReport.vue?vue&type=script&lang=js"
import style0 from "./PowerBIReport.vue?vue&type=style&index=0&id=7805f567&prod&lang=scss"
import style1 from "./PowerBIReport.vue?vue&type=style&index=1&id=7805f567&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports